import { useEffect } from "react";
import useHealthAutoSelection from "./useHealthAutoSelection";
import useHealthCheckLink from "./useHealthCheckLink";
const useHealthSelection = (tree, root, lookup, paths, hasReport, viewMode, initialCheck) => {
  var _a, _b, _c;
  const selectedValue = (_a = tree.selectedState[0]) != null ? _a : root.id;
  const selectedNode = (_b = lookup[selectedValue]) != null ? _b : root;
  const selectedPath = (_c = paths[selectedNode.id]) != null ? _c : [];
  const isRootSelected = selectedNode.id === root.id;
  useEffect(() => {
    if (hasReport && selectedValue && !lookup[selectedValue]) {
      tree.select(root.id);
    }
  }, [hasReport, lookup, root.id, selectedValue, tree]);
  useHealthAutoSelection(tree, root, viewMode, { isRootSelected, hasReport, deepLinked: !!initialCheck });
  useHealthCheckLink(tree, root, lookup, hasReport, initialCheck);
  return { selectedNode, selectedPath, isRootSelected };
};
export default useHealthSelection;
